import { errorHandler } from '../../middleware'
import smartAuthAPI from '../smartbestbuys-api'
import { ICustomerTableData_Data } from './types'

export const fetchCustomerAPI = errorHandler<ICustomerTableData_Data[]>(() => {
  const path = `/customers`
  return smartAuthAPI.get(path)
})
